import { useCallback, useEffect, useRef } from "react";

const useWindowScrollSimple = (cb: Function, delay?: number) => {
  const prevValueRef: { current: NodeJS.Timeout | null } = useRef(null);
  const setValueFn = useCallback(() => cb(), [cb]);

  useEffect(() => {
    const handleScroll = () => {
      if (prevValueRef.current) clearTimeout(prevValueRef.current);
      prevValueRef.current = setTimeout(setValueFn, delay || 250);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [delay, setValueFn]);
};

export default useWindowScrollSimple;
